import { Link } from 'react-router-dom';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, Zap, Wrench, Calculator, Gamepad2 } from 'lucide-react';
import { CategoryInfo } from '@/types/tool';

interface CategoryCardProps {
  category: CategoryInfo;
  toolCount: number;
  index?: number;
}

const iconMap = {
  Zap,
  Wrench,
  Calculator,
  Gamepad2,
};

const CategoryCard = ({ category, toolCount, index = 0 }: CategoryCardProps) => {
  const IconComponent = iconMap[category.icon as keyof typeof iconMap];

  return (
    <Link to={`/#${category.id}`}>
      <Card 
        className="group relative h-full overflow-hidden border-border/50 bg-card transition-all duration-300 hover:border-primary/30 hover:shadow-xl"
        style={{ animationDelay: `${index * 100}ms` }}
      >
        <div className={`absolute inset-0 bg-gradient-to-br ${category.color} opacity-50 transition-opacity duration-300 group-hover:opacity-70`} />
        <CardHeader className="relative">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 text-primary transition-all duration-300 group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground">
            {IconComponent && <IconComponent className="h-7 w-7" />}
          </div>
          <CardTitle className="text-xl font-bold text-card-foreground">
            {category.name}
          </CardTitle>
          <CardDescription className="text-sm text-muted-foreground">
            {category.description}
          </CardDescription>
          <div className="mt-4 flex items-center justify-between">
            <span className="text-sm font-medium text-muted-foreground">
              {toolCount} tools
            </span>
            <div className="flex items-center gap-1 text-sm font-medium text-primary opacity-0 transition-all duration-300 group-hover:opacity-100">
              <span>Explore</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </div>
          </div>
        </CardHeader>
      </Card>
    </Link>
  );
};

export default CategoryCard;
